import { render, staticRenderFns } from "./4-member-profile-extras.vue?vue&type=template&id=617dba86&scoped=true"
import script from "./4-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./4-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./4-member-profile-extras.vue?vue&type=style&index=0&id=617dba86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617dba86",
  null
  
)

export default component.exports